import React,{useCallback,useEffect,useRef,useState} from 'react';
import axios from 'axios';
import { Download } from 'lucide-react';
import { Button } from '../ui/button';
import { useLanguage } from '../../i18n/Locale';
import { guardIdentity } from './guardIdentity';
import { downloadEvidenceDraft } from './evidenceHandoffExport';
import { validQuoteResearch } from './quoteResearchIntegrity';
import { quoteResearchCopy } from './quoteResearchCopy';

const URL=`${process.env.REACT_APP_BACKEND_URL}/api/bot-pilot/executor/quote-research`;
export const QuoteResearch=({data})=>{
  const {language}=useLanguage(),t=quoteResearchCopy[language]||quoteResearchCopy.en;
  const identity=guardIdentity(data),latest=useRef(identity);
  latest.current=identity;
  const [busy,setBusy]=useState(false),[status,setStatus]=useState('');
  const lock=useRef(false),active=useRef(false),serial=useRef(0),request=useRef(null);
  const cancel=useCallback(()=>{
    ++serial.current;request.current?.abort();lock.current=false;
    if(active.current){setBusy(false);setStatus('');}
  },[]);
  useEffect(()=>{
    active.current=true;cancel();
    const hidden=()=>{if(document.visibilityState==='hidden')cancel();};
    window.addEventListener('blur',cancel);document.addEventListener('visibilitychange',hidden);
    return()=>{active.current=false;cancel();window.removeEventListener('blur',cancel);document.removeEventListener('visibilitychange',hidden);};
  },[identity,cancel]);
  const download=async kind=>{
    if(lock.current)return;
    lock.current=true;setBusy(true);setStatus('');request.current=new AbortController();
    const turn=++serial.current,scope=identity;
    const current=()=>active.current&&turn===serial.current&&scope===latest.current;
    try{
      const response=await axios.get(URL,{signal:request.current.signal,timeout:15000});
      if(!current())return;
      if(!await validQuoteResearch(response.data))throw new Error('invalid');
      if(!current())return;
      const doc=response.data.documents.find(item=>item.kind===kind);
      downloadEvidenceDraft(doc.filename,doc.content,'text/markdown;charset=utf-8');setStatus('saved');
    }catch{if(current())setStatus('error');}
    finally{if(current()){lock.current=false;setBusy(false);}}
  };
  return <div className="quote-research" data-testid="quote-research-section">
    <h3 data-testid="quote-research-title">{t.title}</h3>
    <p className="pilot-muted" data-testid="quote-research-date">{t.snapshot}</p>
    <p data-testid="quote-research-found">{t.found}</p>
    <p data-testid="quote-research-pending">{t.pending}</p>
    <p data-testid="quote-research-deployments">{t.none}</p>
    <div className="executor-actions">
      <Button variant="outline" data-testid="quote-research-provider-request" disabled={busy} onClick={()=>download('provider_request')}><Download size={14}/>{t.request}</Button>
      <Button variant="outline" data-testid="quote-research-setup-checklist" disabled={busy} onClick={()=>download('setup_checklist')}><Download size={14}/>{t.checklist}</Button>
    </div>
    {busy&&<p role="status" data-testid="quote-research-loading">{t.preparing}</p>}
    {status&&<p role={status==='error'?'alert':'status'} data-testid={`quote-research-${status}`}>{t[status]}</p>}
    <p className="pilot-muted" data-testid="quote-research-boundary">{t.boundary}</p>
  </div>;
};